import React from 'react';

import { AnalyticsAll } from '../features/AnalyticsAll';
import { AnalyticMembers } from '../features/AnalyticMembers';
import { AnalyticModeration } from '../features/AnalyticModeration';
import { AnalyticsFinance } from '../features/AnalyticFinance';
import { CHAT_TYPE } from '../../communities/components/Chats/interface/chats.interface';
import { AnalyticPosts } from '../features/AnalyticPosts';
import { AnalyticMessages } from '../features/AnalyticMessages';
import { RecommendationContainer } from '../features/Recommendation/containers/RecommendationContainer';
import { useAppSelector } from '../../../store';
import { selectAnalyticsSelection } from '../store/analyticSelectorSlice';
import { selectAnalyticsFilters } from '../store/analyticFiltersSlice';

export const PageContent = () => {
    const filters = useAppSelector(selectAnalyticsFilters);
    const { current } = useAppSelector(selectAnalyticsSelection);

    return (
        <>
            {(() => {
                const layoutMap: Record<string, React.ReactNode> = {
                    all: <AnalyticsAll />,
                    members: <AnalyticMembers />,
                    moderation: <AnalyticModeration />,
                    finance: <AnalyticsFinance />,
                };
                const renderMessagesLayout = () => {
                    if (current?.type === CHAT_TYPE.CHANNEL) {
                        return <AnalyticPosts />;
                    }
                    return <AnalyticMessages />;
                };
                return filters.viewAnalitycsType === 'messages'
                    ? renderMessagesLayout()
                    : layoutMap[filters.viewAnalitycsType];
            })()}

            {filters.chat && <RecommendationContainer />}
        </>
    );
};
